export const AUTH_TOKEN = 'nce-token'